const Reply = ({ color }) => {
  return (
    <svg
      width='16'
      height='12'
      viewBox='0 0 16 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ marginRight: "18px" }}
    >
      <path
        d='M14.6667 11.8333C14.4306 11.8333 14.2328 11.7533 14.0734 11.5933C13.9134 11.4339 13.8334 11.2361 13.8334 11V8.5C13.8334 7.80556 13.5903 7.21528 13.1042 6.72917C12.6181 6.24306 12.0278 6 11.3334 6H3.66669L6.10419 8.4375C6.25696 8.59028 6.33335 8.77778 6.33335 9C6.33335 9.22222 6.25002 9.41667 6.08335 9.58333C5.93058 9.73611 5.73613 9.8125 5.50002 9.8125C5.26391 9.8125 5.06946 9.73611 4.91669 9.58333L1.08335 5.75C1.00002 5.66667 0.941131 5.57639 0.906687 5.47917C0.871687 5.38194 0.854187 5.27778 0.854187 5.16667C0.854187 5.05556 0.871687 4.95139 0.906687 4.85417C0.941131 4.75694 1.00002 4.66667 1.08335 4.58333L4.93752 0.729167C5.0903 0.576389 5.2778 0.5 5.50002 0.5C5.72224 0.5 5.91669 0.583333 6.08335 0.75C6.23613 0.902778 6.31252 1.09722 6.31252 1.33333C6.31252 1.56944 6.23613 1.76389 6.08335 1.91667L3.66669 4.33333H11.3334C12.4861 4.33333 13.4689 4.73944 14.2817 5.55167C15.0939 6.36444 15.5 7.34722 15.5 8.5V11C15.5 11.2361 15.42 11.4339 15.26 11.5933C15.1006 11.7533 14.9028 11.8333 14.6667 11.8333Z'
        fill={color}
      />
    </svg>
  );
};

export default Reply;
